import { axiosInstance } from "src/api/axiosInstance";
import type {
  ApiResponse,
  PageContent,
  CommonCodeItem,
  CommonCodeQuery,
  CommonCodeCreatePayload,
  CommonCodeUpdatePayload,
} from "src/types/common/commonCodeTypes";

const BASE = "/v1/admin/common/code";

/** 코드 목록 조회 (그룹 선택 후 검색) */
export const getCommonCodeListApi = async (
  grpCode: string,
  params: CommonCodeQuery
): Promise<ApiResponse<PageContent<CommonCodeItem>>> => {
  const res = await axiosInstance.get<ApiResponse<PageContent<CommonCodeItem>>>(
    `${BASE}/list/${grpCode}`,
    {
      params: {
        ...params,
        code: params.code?.trim() || undefined,
        codeName: params.codeName?.trim() || undefined,
        useYn: typeof params.useYn === "boolean" ? params.useYn : undefined,
        deleted: typeof params.deleted === "boolean" ? params.deleted : undefined,
        order: params.order || "codeOrder,asc",
      },
    }
  );
  return res.data;
};

/** 생성: 배열로 한번에 */
export const createCommonCodeApi = async (
  payloads: CommonCodeCreatePayload[]
): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.post<ApiResponse<null>>(`${BASE}`, payloads);
  return res.data;
};

/** 수정: 배열로 한번에 */
export const updateCommonCodeApi = async (
  payloads: CommonCodeUpdatePayload[]
): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.put<ApiResponse<null>>(`${BASE}`, payloads);
  return res.data;
};

/** 삭제 */
export const deleteCommonCodeApi = async (codeId: number): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.delete<ApiResponse<null>>(`${BASE}/${codeId}`);
  return res.data;
};

/**
 * 정렬순서 일괄 변경
 * (API 스펙이 보통 codeId + codeOrder 조합이라 이렇게 잡음)
 */
export type CommonCodeOrderPayload = {
  codeId: number;
  codeOrder: number;
};

export const updateCommonCodeOrderApi = async (
  payloads: CommonCodeOrderPayload[]
): Promise<ApiResponse<null>> => {
  const res = await axiosInstance.put<ApiResponse<null>>(`${BASE}/order`, payloads);
  return res.data;
};
